/* eslint-disable react-hooks/rules-of-hooks */
import { useGetApiRequests } from "../../../common/CommonExport";
export interface EmployeeNode {
  firstName: string;
  lastName: string;
  employeeId: number;
  officialEmail: string;
  designationName: string;
  reportingManagerId: number | null;
  subordinates: EmployeeNode[];
}

const organisationChart = useGetApiRequests("organisationChart", "GET");

export const getOrganisationChartData = async (orgId: number): Promise<any> => {
  try {
    const response = await organisationChart(null, { organisationId: orgId });
    if ("data" in response) {
      return response.data;
    } else {
      console.error("Response is not an AxiosResponse:", response);
      return null;
    }
  } catch (error) {
    console.error("Error fetching organization chart data:", error);
    throw error;
  }
};

export const getSiblingIds = (orgData: EmployeeNode[], parentNode: EmployeeNode | null, excludeId?: number): number[] => {
  if (!parentNode) return orgData.map((emp) => emp.employeeId).filter((id) => id !== excludeId);
  return parentNode.subordinates.map((emp) => emp.employeeId).filter((id) => id !== excludeId);
};

export const getAllDescendantIds = (node: EmployeeNode): number[] => {
  let ids: number[] = [];
  if (!node.subordinates || node.subordinates.length === 0) return ids;
  node.subordinates.forEach((sub) => {
    ids.push(sub.employeeId);
    ids = ids.concat(getAllDescendantIds(sub));
  });
  return ids;
};

export const buildTree = (node: EmployeeNode, expandedNodes: Set<number>, parentNode: EmployeeNode | null = null): any => {
  const isExpanded = expandedNodes.has(node.employeeId);
  return {
    name: `${node.firstName} ${node.lastName}`,
    title: node.designationName,
    employeeId: node.employeeId,
    originalData: node,
    parentNode,
    children: isExpanded ? node.subordinates.map((sub) => buildTree(sub, expandedNodes, node)) : [],
  };
};

export const centerChart = (chartWrapperRef: React.RefObject<HTMLDivElement>) => {
  if (chartWrapperRef.current) {
    const chart = chartWrapperRef.current.querySelector(".orgchart-container") as HTMLElement;
    if (chart) {
      const scrollX = chart.scrollWidth / 2 - chart.clientWidth / 2;
      const scrollY = chart.scrollHeight / 2 - chart.clientHeight / 2;
      chart.scrollTo({ left: scrollX, top: scrollY, behavior: "smooth" });
    }
  }
};
